import React from "react";
import KeyValue from "../../shared/KeyValue";
import { t } from "../../../../i18n";
import CustomButton from "../../shared/CustomButton";
import { EditPencil01, EditPencil02 } from "../../normalizer";
import UserInfoEdit from "./UserInfoEdit";

const UserInfo = (props) => {
  const {
    onEditGeneralData,
    editingUserGeneralData,
    onEditSubmit,
    onEditCancel,
    onChangeGender,
    // saveVersion increments in the container after each successful profile
    // save so we can use it as a React key and guarantee UserInfoEdit (which
    // uses uncontrolled defaultValue inputs) always remounts with fresh data.
    saveVersion,
    ...user
  } = props;

  const genderValue =
    user.gender === "male" ? t("gamification2026.profile.male") : t("gamification2026.profile.female") ;
  
  const [isValid, setIsValid] = React.useState(user && user.first_name && user.last_name && user.email && user.phone && user.nif);

  const validate = (data) => {
    if (data && data.first_name && data.last_name && data.email && data.phone && data.nif) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  return (
    <div className="user-info-container">
      <div className="row gl-profile__info-data gl-profile__info-block m-0">
        <div className="user-info-container-title">
          <h5 className="user-info-container-title-text">Dados Pessoais</h5>
          {editingUserGeneralData && (
            <div className="user-info-container-title-edit">
              Edite os campos abaixo e guarde as alterações
            </div>
          )}
        </div>
      </div>
      {!editingUserGeneralData && (
        <>
          <div className="row gl-profile__info-data gl-profile__info-block m-0">
            <div className="col-md-4 col-sm-4 col-xs-12 remove-padding">
              <KeyValue
                title={t("gamification2026.profile.name")}
                value={`${user.first_name} ${user.last_name}`}
              />
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12 remove-padding">
              <KeyValue
                title={t("gamification2026.profile.gender")}
                value={genderValue}
              />
            </div>
          </div>
          <div className="row gl-profile__info-data gl-profile__info-block m-0">
            <div className="col-md-4 col-sm-4 col-xs-12 remove-padding">
              <KeyValue
                title={t("gamification2026.profile.email")}
                value={user.email}
              />
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12 remove-padding">
              <KeyValue
                title={t("gamification2026.profile.phone")}
                value={user.phone}
              />
            </div>
          </div>
          <div className="row gl-profile__info-data gl-profile__info-block m-0">
            <div className="col-md-4 col-sm-4 col-xs-12 remove-padding">
              <KeyValue
                title={t("gamification2026.profile.nif")}
                value={user.nif}
              />
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12 remove-padding">
              <KeyValue
                title={t("gamification2026.profile.identifier")}
                value={user.login}
              />
            </div>
          </div>
          <div className="flex justify-end gl-profile__between">
            <CustomButton small tight link onClick={onEditGeneralData}>
              <EditPencil01 width={20} height={20} />
              {t("gamification2026.profile.edit")}
            </CustomButton>
          </div>
        </>
      )}
      {editingUserGeneralData && (
        <div className="user-info-edit-container">
          <UserInfoEdit
            key={saveVersion}
            onChange={validate}
            onChangeGender={onChangeGender}
            onEditSubmit={onEditSubmit}
            {...user}
          />
          <div className="user-info-edit-actions">
            <CustomButton secondary onClick={onEditCancel}>
              {t("gamification2026.profile.cancel")}
            </CustomButton>
            <CustomButton
              disabled={!isValid}
              type={"submit"}
              form={"user-update-form"}
            >
              {t("gamification2026.profile.save")}
            </CustomButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
